// extracted by mini-css-extract-plugin
export default {"image":"M4-z","loaded":"N4-z"};